import React from "react";
import "../divider/styles.css";

const Divider = ({ type = "horizontal", borderStyle = "solid", page = "" }) => {
  const finalClassName =
    page === "dashboard" ? "dashboard" : `${type} ${borderStyle}`;
  return <hr className={`divider ${finalClassName} `} />;
};

export default Divider;
